import { Inject } from '@angular/core';
import { Apollo } from 'apollo-angular';
import { NXDataSourcePrime } from '../../services/dataSource/NXDataSourcePrime';
import { User } from '../../entities/user/user';
import * as fromGraphQl from './graphql';

export class UserDataSource extends NXDataSourcePrime<User> {
  constructor(
    apollo: Apollo,
    @Inject('env') environment : any
    ) {
    super(apollo, fromGraphQl.USERS_QUERY, environment);
  }
  handleSubscriptionResult(data: fromGraphQl.UsersQueryResponse): void {
    super.setSubject(
      data.users?.content ? User.createUsers(data.users?.content) : [],
      data.users?.totalElements ? data.users.totalElements : 0
    );
  }

  loadUsers(variables: any): void {
    this.querySubscription?.unsubscribe();
    this.subscribeToQuery(variables);
  }
}
